'use client'
import React, { useState } from 'react'
import CustomButton from '../Buttons/CustomButton'
import Link from 'next/link'


const DemoButton = ({...props}) => {
    const [isOpen, setIsOpen] = useState(false)
  return (<>
  <Link target="_blank" href={'/book-appointment'}>
    <CustomButton Text={"Request a Demo"}  onClick={() => setIsOpen(true)} {...props}/>
    </Link>
  </>

  )
}

export default DemoButton